/* Move a language basket through an owned popup. The destination is verified
 * before exact source line-key cleanup, then both origins confirm completion. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) { root.NLLanguageCartRelayCore = api; root.NLLanguageCartRelay = api.install(root); }
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var ORIGINS = ['https://naturlabs.cz', 'https://naturlabs.eu'];
  var RELAY_COPY_ENABLED = true;
  var NONCE = /^[a-f0-9]{32}$/;
  function unsupported() { var error = new Error('Unsupported cart state'); error.reason = 'unsupported'; throw error; }
  function integer(value, positive) {
    if (!Number.isSafeInteger(value) || value < (positive ? 1 : 0)) unsupported();
    return value;
  }
  function text(value, max) {
    if (typeof value !== 'string' || value.length > max) unsupported();
    return value;
  }
  // Same-market delivery metadata is cart content, not a quoted shipping rate.
  // Keep complete reviewed Globe points byte-for-byte. Home is the default and
  // can be recreated by the widget even after the source basket is emptied.
  var GLOBE_KEYS = ['globe_DeliveryMethod', 'globe_PickupPointId', 'globe_PickupPointName', 'globe_PickupPointAddress', 'globe_PickupPointData'];
  function deliveryAttributes(value) {
    var deliveryKeys = Object.keys(value).filter(function (key) { return /globe|pickup|shipping|delivery|carrier|packeta|zasilkovna/i.test(key); });
    if (!deliveryKeys.length) return value;
    if (deliveryKeys.some(function (key) { return GLOBE_KEYS.indexOf(key) < 0; })) unsupported();
    if (value.globe_DeliveryMethod === 'home' && deliveryKeys.length === 1) {
      return Object.fromEntries(Object.entries(value).filter(function (entry) { return entry[0] !== 'globe_DeliveryMethod'; }));
    }
    if (value.globe_DeliveryMethod !== 'pickup' || deliveryKeys.length !== GLOBE_KEYS.length) unsupported();
    GLOBE_KEYS.forEach(function (key) { if (!text(value[key], 10000)) unsupported(); });
    var point;
    try { point = JSON.parse(value.globe_PickupPointData); } catch (_) { unsupported(); }
    if (!point || point.countryCode !== 'CZ' || !point.addressObject || point.addressObject.country !== 'cz' ||
        point.id !== value.globe_PickupPointId || point.name !== value.globe_PickupPointName || point.address !== value.globe_PickupPointAddress ||
        !(point.provider === 'ppl' && point.type === 'ParcelBox' || point.provider === 'packeta' && ['branch', 'zbox'].indexOf(point.type) >= 0)) unsupported();
    return value;
  }
  function map(value, attributes) {
    if (!value || Object.prototype.toString.call(value) !== '[object Object]') unsupported();
    if (attributes) value = deliveryAttributes(value);
    var entries = Object.keys(value).sort().map(function (key) {
      text(key, 200);
      if (!key || /^(?:__proto__|prototype|constructor)$/.test(key) || /token|cookie|secret|password|credential|(?:^|[_-])auth/i.test(key)) unsupported();
      if (attributes && /globe|pickup|shipping|delivery|carrier|packeta|zasilkovna/i.test(key) && GLOBE_KEYS.indexOf(key) < 0) unsupported();
      var item = value[key];
      if (!['string', 'number', 'boolean'].includes(typeof item) || (typeof item === 'number' && !Number.isFinite(item)) || String(item).length > 10000) unsupported();
      // Shopify JSON properties may contain numbers (Ritual size) or booleans.
      // Retain their types so identity, receipts and destination writes stay exact.
      return [key, item];
    });
    if (entries.length > 100) unsupported();
    return Object.fromEntries(entries);
  }
  function has(value) { return Array.isArray(value) ? value.length > 0 : value != null && value !== false && value !== 0; }
  function identity(item) { return JSON.stringify([item.variantId, item.productId, item.sku, item.properties]); }
  function normalize(cart, context) {
    if (!context || context.country !== 'CZ' || context.currency !== 'CZK' || context.selectedShipping || context.unsavedNote) unsupported();
    if (!cart || cart.currency !== 'CZK' || cart.total_discount !== 0 || !Array.isArray(cart.items) || cart.items.length > 100) unsupported();
    if (has(cart.discount_codes) || has(cart.cart_level_discount_applications) || has(cart.discount_applications)) unsupported();
    var items = cart.items.map(function (item) {
      if (!item || item.remote || item.has_components || has(item.selling_plan_allocation) || has(item.selling_plan) || has(item.selling_plan_id) || has(item.item_components) || has(item.components) || has(item.line_item_group) || has(item.parent_relationship) || has(item.parent_id) || has(item.parent_line_key) || has(item.discount_allocations) || has(item.line_level_discount_allocations) || has(item.discounts) || has(item.total_discount)) unsupported();
      var price = integer(item.final_price, false);
      if (item.original_price !== price) unsupported();
      return { variantId: integer(item.variant_id, true), productId: integer(item.product_id, true), sku: text(item.sku, 200), quantity: integer(item.quantity, true), properties: map(item.properties == null ? {} : item.properties, false), unitPrice: price };
    }).sort(function (a, b) { return identity(a).localeCompare(identity(b)); });
    var count = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var total = items.reduce(function (sum, item) { return sum + item.quantity * item.unitPrice; }, 0);
    if (integer(cart.item_count, false) !== count || integer(cart.total_price, false) !== total || new Set(items.map(identity)).size !== items.length) unsupported();
    var model = { v: 1, country: 'CZ', currency: 'CZK', items: items, note: cart.note === null ? '' : text(cart.note, 20000), attributes: map(cart.attributes, true), totalPrice: total };
    if (JSON.stringify(model).length > 200000) unsupported();
    return model;
  }
  function validate(model) {
    if (!model || model.v !== 1 || !Array.isArray(model.items)) unsupported();
    var allowed = ['v', 'country', 'currency', 'items', 'note', 'attributes', 'totalPrice'];
    if (Object.keys(model).some(function (key) { return !allowed.includes(key); })) unsupported();
    var items = model.items.map(function (item) {
      if (!item || Object.keys(item).some(function (key) { return !['variantId', 'productId', 'sku', 'quantity', 'properties', 'unitPrice'].includes(key); })) unsupported();
      return { variant_id: item.variantId, product_id: item.productId, sku: item.sku, quantity: item.quantity, properties: item.properties, final_price: item.unitPrice, original_price: item.unitPrice };
    });
    return normalize({ currency: model.currency, items: items, item_count: items.reduce(function (sum, item) { return sum + item.quantity; }, 0), total_price: model.totalPrice, total_discount: 0, note: model.note, attributes: model.attributes }, { country: model.country, currency: model.currency });
  }
  function fingerprint(model) { return JSON.stringify(validate(model)); }
  function plan(source, target) {
    source = validate(source); target = validate(target);
    if (fingerprint(source) === fingerprint(target)) return 'identical';
    if (!target.items.length && !target.note && !Object.keys(target.attributes).length) return 'copy';
    return 'conflict';
  }
  function createReceiver(options) {
    if (ORIGINS.indexOf(options.origin) < 0 || !options.opener || typeof options.withLock !== 'function' || typeof options.assertNoPending !== 'function') unsupported();
    var expectedOrigin = ORIGINS.find(function (origin) { return origin !== options.origin; });
    var phase = 'idle', nonce = null, before = null, desired = null, completion = null, holdTimer = null, cleanupChecked = false;
    function observe(name) { if (typeof options.observe === 'function') options.observe(name); }
    function send(type, body) { options.send(options.opener, expectedOrigin, Object.assign({ v: 1, nonce: nonce, type: type }, body || {})); }
    async function receive(event) {
      var message = event && event.data;
      if (!event || event.isTrusted !== true || event.origin !== expectedOrigin || event.source !== options.opener || !message || message.v !== 1 || !NONCE.test(message.nonce)) return false;
      if (nonce && message.nonce !== nonce) return false;
      if (message.type === 'abort' && completion) { completion.reject(new Error('Source aborted')); return true; }
      if (message.type === 'cleanup-check' && phase === 'prepared-target' && completion) {
        phase = 'checking-cleanup';
        try {
          var checkpoint = validate(await options.read());
          if (message.fingerprint !== fingerprint(desired) || fingerprint(checkpoint) !== fingerprint(desired)) throw new Error('Destination changed before source cleanup');
          await options.assertNoPending();
          cleanupChecked = true; phase = 'prepared-target';
          send('cleanup-ready', { fingerprint: fingerprint(checkpoint) });
        } catch (error) { completion.reject(error); }
        return true;
      }
      if (message.type === 'source-moved' && phase === 'prepared-target' && completion) {
        if (!cleanupChecked || message.fingerprint !== fingerprint(desired)) return false;
        completion.resolve(true); return true;
      }
      if (message.type === 'inspect' && phase === 'idle') {
        nonce = message.nonce; phase = 'reading';
        observe('peer-origin-window-nonce-validated');
        try { before = validate(await options.read()); observe('own-cart-read-before-write'); phase = 'prepared'; send('snapshot', { cart: before }); }
        catch (_) { phase = 'failed'; send('error', { reason: 'unavailable' }); }
        return true;
      }
      if (message.type !== 'commit' || !['prepared', 'done'].includes(phase)) return false;
      var replay = phase === 'done'; phase = 'committing';
      try {
        var source = validate(message.cart);
        if (options.requireMove && message.move !== true) unsupported();
        if (message.expected !== fingerprint(before) || !source.items.length || (replay && fingerprint(source) !== fingerprint(desired))) unsupported();
        await options.withLock(async function () {
          var current = validate(await options.read());
          if (replay && fingerprint(current) !== fingerprint(desired)) throw new Error('Destination changed');
          if (!replay && fingerprint(current) !== fingerprint(before)) throw new Error('Destination changed');
          var decision = plan(source, current);
          if (decision === 'conflict') throw new Error('Different destination basket');
          if (!replay && decision === 'copy') { observe('copy-requested-after-fresh-read'); await options.copy(source, current); }
          var after = validate(await options.read());
          if (fingerprint(after) !== fingerprint(source)) throw new Error('Destination readback mismatch');
          await options.assertNoPending();
          desired = after;
          if (message.move === true) {
            completion = deferred(); cleanupChecked = false; phase = 'prepared-target';
            holdTimer = setTimeout(function () { completion.reject(new Error('Source completion timeout')); }, options.holdTimeoutMs || 45000);
          } else phase = 'done';
          observe('receipt-after-exact-readback'); send('verified', { fingerprint: fingerprint(after) });
          if (message.move === true) {
            try {
              await completion.promise;
              var final = validate(await options.read());
              if (fingerprint(final) !== fingerprint(desired)) throw new Error('Destination changed before completion');
              await options.assertNoPending();
              phase = 'done'; observe('move-complete-under-target-lock');
              send('moved', { fingerprint: fingerprint(final) });
            } finally { clearTimeout(holdTimer); completion = null; }
          }
        });
      } catch (_) { phase = 'failed'; send('error', { reason: 'not-transferred' }); }
      return true;
    }
    return { receive: receive, abort: function () { if (completion) completion.reject(new Error('Destination page closed')); } };
  }
  function deferred() {
    var resolve, reject;
    var promise = new Promise(function (yes, no) { resolve = yes; reject = no; });
    promise.catch(function () {});
    return { promise: promise, resolve: resolve, reject: reject };
  }
  function createSource(options) {
    var target;
    try { target = new URL(options.target); } catch (_) { unsupported(); }
    if (ORIGINS.indexOf(options.origin) < 0 || ORIGINS.indexOf(target.origin) < 0 || target.origin === options.origin || target.search || target.hash || target.username || target.password || /\/(?:account|checkout|checkouts|admin)(?:\/|$)/.test(target.pathname) || !NONCE.test(options.nonce)) unsupported();
    integer(options.theme, true);
    // Shopify can leave the preview on a cross-domain navigation. Keep this
    // public theme identifier only on the preview popup, never on MAIN or the
    // native localization form. No cart state or credentials enter the URL.
    if (options.themeRole === 'unpublished' || options.themeRole === 'development') target.searchParams.set('preview_theme_id', String(options.theme));
    function observe(name) { if (typeof options.observe === 'function') options.observe(name); }
    var snapshot = deferred(), receipt = deferred(), cleanupReady = deferred(), moved = deferred();
    var phase = 'opening', desiredFingerprint = null, popup = null, closed = false, destinationSaved = false;
    var deadline = Date.now() + (options.timeoutMs || 45000);
    var timeout, monitor, remove;
    function close() {
      if (closed) return;
      var succeeded = phase === 'done';
      closed = true; phase = 'closed';
      clearTimeout(timeout); clearInterval(monitor);
      if (remove) remove();
      try {
        if (popup && !popup.closed) {
          options.send(popup, target.origin, { v: 1, type: 'abort', nonce: options.nonce });
          if (!(options.requireMove && destinationSaved && !succeeded)) popup.close();
        }
      } catch (_) {}
      snapshot.reject(new Error('Popup closed'));
      receipt.reject(new Error('Popup closed'));
      moved.reject(new Error('Popup closed'));
      cleanupReady.reject(new Error('Popup closed'));
    }
    function fail() {
      snapshot.reject(new Error('Cart transfer unavailable'));
      receipt.reject(new Error('Cart transfer unavailable'));
      moved.reject(new Error('Cart transfer unavailable'));
      cleanupReady.reject(new Error('Cart transfer unavailable'));
      close();
    }
    function receive(event) {
      var message = event && event.data;
      if (closed || !event || event.isTrusted !== true || event.origin !== target.origin || event.source !== popup || !message || message.v !== 1) return;
      if (message.type === 'ready' && phase === 'opening') {
        if (message.theme !== options.theme || message.country !== 'CZ' || message.currency !== 'CZK') { fail(); return; }
        observe('popup-origin-window-theme-validated');
        phase = 'inspecting';
        options.send(popup, target.origin, { v: 1, type: 'inspect', nonce: options.nonce });
        return;
      }
      if (message.nonce !== options.nonce) return;
      if (message.type === 'error') { fail(); return; }
      if (message.type === 'snapshot' && phase === 'inspecting') {
        try { var model = validate(message.cart); observe('snapshot-nonce-validated'); phase = 'prepared'; snapshot.resolve(model); }
        catch (_) { fail(); }
      }
      if (message.type === 'verified' && phase === 'committing') {
        if (message.fingerprint !== desiredFingerprint) { fail(); return; }
        destinationSaved = true; phase = 'received'; receipt.resolve(true);
      }
      if (message.type === 'moved' && phase === 'moving-source') {
        if (message.fingerprint !== desiredFingerprint) { fail(); return; }
        moved.resolve(true);
      }
      if (message.type === 'cleanup-ready' && phase === 'checking-target') {
        if (message.fingerprint !== desiredFingerprint) { fail(); return; }
        cleanupReady.resolve(true);
      }
    }
    remove = options.listen(receive);
    try { popup = options.open(target.href); }
    catch (_) { close(); throw new Error('Popup unavailable'); }
    if (!popup) { close(); throw new Error('Popup unavailable'); }
    observe('popup-opened-by-user-action');
    timeout = setTimeout(fail, options.timeoutMs || 45000);
    monitor = setInterval(function () { try { if (popup.closed) fail(); } catch (_) { fail(); } }, 250);
    function assertLive() {
      if (closed || !popup || popup.closed || Date.now() >= deadline) throw new Error('Cart transfer expired');
      return true;
    }
    async function transfer(initial) {
      try {
        initial = validate(initial);
        if (!initial.items.length) unsupported();
        var destination = await snapshot.promise;
        if (plan(initial, destination) === 'conflict') throw new Error('Different destination basket');
        async function commitAndMove() {
          assertLive();
          var before = validate(await options.read());
          if (fingerprint(before) !== fingerprint(initial)) throw new Error('Source basket changed');
          desiredFingerprint = fingerprint(initial); phase = 'committing';
          observe('source-unchanged-before-commit');
          options.send(popup, target.origin, { v: 1, type: 'commit', nonce: options.nonce, cart: initial, expected: fingerprint(destination), move: options.requireMove === true });
          await receipt.promise; assertLive();
          var after = validate(await options.read());
          if (fingerprint(after) !== desiredFingerprint) throw new Error('Source basket changed');
          observe('source-unchanged-after-receipt');
          if (options.requireMove) {
            if (typeof options.moveSource !== 'function') unsupported();
            phase = 'checking-target';
            options.send(popup, target.origin, { v: 1, type: 'cleanup-check', nonce: options.nonce, fingerprint: desiredFingerprint });
            await cleanupReady.promise; assertLive();
            phase = 'moving-source';
            await options.moveSource(initial, assertLive); assertLive();
            observe('source-empty-after-exact-linekey-update');
            options.send(popup, target.origin, { v: 1, type: 'source-moved', nonce: options.nonce, fingerprint: desiredFingerprint });
            await moved.promise; assertLive();
          }
          phase = 'done'; clearTimeout(timeout); clearInterval(monitor);
          return true;
        }
        if (options.requireMove) {
          if (typeof options.withSourceLock !== 'function') unsupported();
          return await options.withSourceLock(commitAndMove);
        }
        return await commitAndMove();
      } catch (error) {
        if (destinationSaved && options.requireMove) error.reason = 'destination-saved';
        close(); throw error;
      }
    }
    function navigate() {
      if (closed || phase !== 'done' || typeof options.navigate !== 'function') throw new Error('Basket movement is not complete');
      options.navigate(target.href);
    }
    return { transfer: transfer, close: close, navigate: navigate };
  }
  function createCoordinator(win) {
    var pending = new Set();
    var name = 'nl-language-cart-relay-v1';
    function runMutation(work) {
      var run = Promise.resolve().then(function () {
        // Even a read-only relay can issue an identical-cart receipt. Its
        // ordinary writers therefore always participate in the same lock.
        if (!win.navigator || !win.navigator.locks) return work();
        return win.navigator.locks.request(name, { mode: 'exclusive' }, work);
      });
      var settled = run.catch(function () {});
      pending.add(settled);
      settled.then(function () { pending.delete(settled); });
      return run;
    }
    async function whenIdle() { while (pending.size) await Promise.all(Array.from(pending)); }
    async function assertNoPending() {
      if (pending.size) throw new Error('Destination mutation pending');
      if (!win.navigator || !win.navigator.locks || typeof win.navigator.locks.query !== 'function') throw new Error('Cart lock inspection unavailable');
      var state = await win.navigator.locks.query();
      if (pending.size || state.pending.some(function (lock) { return lock.name === name; })) throw new Error('Destination mutation pending');
    }
    return { runMutation: runMutation, whenIdle: whenIdle, hasPending: function () { return pending.size > 0; }, assertNoPending: assertNoPending };
  }
  function createBrowserAdapter(win, options) {
    options = options || {};
    var coordinator = options.coordinator || createCoordinator(win);
    var lockedDepth = 0;
    var transferId = options.transferId;
    function optionsTransferFetch(url, requestOptions) {
      if (transferId) {
        if (!win.NLCartTransferFence) return Promise.reject(new Error('Basket fence unavailable'));
        return win.NLCartTransferFence.ownerFetch(transferId, url, requestOptions);
      }
      return win.fetch(url, requestOptions);
    }
    var editedNotes = new WeakSet();
    function rememberNoteEdit(event) {
      var field = event.target;
      if (field && typeof field.matches === 'function' && field.matches('[data-w2-note-input], [data-cart-note]')) editedNotes.add(field);
    }
    if (typeof win.document.addEventListener === 'function') {
      win.document.addEventListener('input', rememberNoteEdit, true);
      win.document.addEventListener('change', rememberNoteEdit, true);
    }
    function observe(name) { if (typeof options.observe === 'function') options.observe(name); }
    function endpoint(suffix) {
      var root = win.Shopify && win.Shopify.routes && win.Shopify.routes.root;
      if (typeof root !== 'string') unsupported();
      var url = new URL(root + suffix, win.location.origin);
      if (url.origin !== win.location.origin || url.search || url.hash || url.username || url.password) unsupported();
      return url.href;
    }
    function context(cart) {
      var shipping = win.document.querySelector('input[name^="globe-delivery-method"]:checked');
      var unsaved = Array.from(win.document.querySelectorAll('[data-w2-note-input], [data-cart-note]')).some(function (field) {
        // A closed drawer can still contain a pending debounced edit. Untouched
        // server markup may be stale after our own write, so only edited fields
        // have to agree with the fresh authoritative note.
        var dirty = editedNotes.has(field) || typeof field.defaultValue !== 'string' || field.value !== field.defaultValue;
        return dirty && field.value !== (cart.note || '');
      });
      return { country: win.Shopify && win.Shopify.country, currency: win.Shopify && win.Shopify.currency && win.Shopify.currency.active, selectedShipping: !!shipping && ['home', 'pickup'].indexOf(shipping.value) < 0, unsavedNote: unsaved };
    }
    async function request(suffix, body) {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      try {
        if (!win.NL || !win.NL.cart || typeof win.NL.cart.whenIdle !== 'function') unsupported();
        await Promise.race([lockedDepth ? Promise.resolve() : Promise.all([win.NL.cart.whenIdle(), coordinator.whenIdle()]), new Promise(function (_resolve, reject) {
          controller.signal.addEventListener('abort', function () { reject(new Error('Cart queue unavailable')); }, { once: true });
        })]);
        if (controller.signal.aborted) throw new Error('Cart queue unavailable');
        var options = { credentials: 'same-origin', redirect: 'error', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } };
        if (body !== undefined) {
          options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body);
        }
        var response = await (optionsTransferFetch(endpoint(suffix), options));
        if (!response.ok) { var failure = new Error('Cart request unavailable'); failure.status = response.status; throw failure; }
        if (response.redirected || typeof response.url !== 'string' || response.url !== endpoint(suffix)) throw new Error('Cart response origin or redirect mismatch');
        var data = await response.json();
        if (data && typeof data.status === 'number' && data.status >= 400) { var failure = new Error('Cart request unavailable'); failure.status = data.status; throw failure; }
        return data;
      } finally { clearTimeout(timeout); }
    }
    async function read() { var raw = await request('cart.js'); observe('first-party-cart-read'); return normalize(raw, context(raw)); }
    function sourceKeys(raw) {
      if (!raw || !Array.isArray(raw.items)) unsupported();
      var rows = raw.items.map(function (item) {
        var key = text(item.key, 200);
        if (!new RegExp('^' + integer(item.variant_id, true) + ':[a-f0-9]+$').test(key)) unsupported();
        return [identity({ variantId: item.variant_id, productId: item.product_id, sku: item.sku, properties: map(item.properties || {}, false) }), key];
      }).sort(function (a, b) { return a[0].localeCompare(b[0]); });
      if (new Set(rows.map(function (row) { return row[1]; })).size !== rows.length) unsupported();
      return rows;
    }
    async function removeOriginal(model, original, alive) {
      if (options.writeEnabled !== true || !lockedDepth) throw new Error('Source movement is disabled or unlocked');
      model = validate(model);
      if (fingerprint(normalize(original, context(original))) !== fingerprint(model)) throw new Error('Original source differs');
      var originalKeys = sourceKeys(original);
      var current = await request('cart.js');
      if (fingerprint(normalize(current, context(current))) !== fingerprint(model) || JSON.stringify(sourceKeys(current)) !== JSON.stringify(originalKeys)) throw new Error('Source identity or line keys changed');
      await coordinator.assertNoPending();
      // Recheck unsaved note edits after the asynchronous lock inspection.
      normalize(current, context(current));
      if (typeof alive !== 'function' || alive() === false) throw new Error('Destination receipt expired');
      var updates = Object.fromEntries(originalKeys.map(function (row) { return [row[1], 0]; }));
      var attributes = Object.fromEntries(Object.keys(model.attributes).map(function (key) { return [key, '']; }));
      observe('source-exact-linekey-cleanup-started');
      await request('cart/update.js', { updates: updates, note: '', attributes: attributes });
      var after = await request('cart.js');
      // This is the raw server postcondition. The old note textarea still
      // contains our transferred text until this empty state is confirmed.
      var empty = normalize(after, { country: win.Shopify.country, currency: win.Shopify.currency.active });
      if (empty.items.length || empty.note || Object.keys(empty.attributes).length) throw new Error('Source cleanup readback is not empty');
      await coordinator.assertNoPending();
      if (alive() === false) throw new Error('Destination receipt expired');
      win.document.querySelectorAll('[data-w2-note-input], [data-cart-note]').forEach(function (field) { field.value = ''; field.defaultValue = ''; });
      editedNotes = new WeakSet();
      if (typeof win.document.dispatchEvent === 'function' && typeof win.CustomEvent === 'function') win.document.dispatchEvent(new win.CustomEvent('nl:cart:moved'));
      observe('source-raw-empty-readback-verified');
      return true;
    }
    function busy() {
      var body = win.document.body;
      if (!body) return function () {};
      var previous = body.inert, aria = body.getAttribute('aria-busy');
      body.inert = true; body.setAttribute('aria-busy', 'true');
      return function () { body.inert = previous; if (aria === null) body.removeAttribute('aria-busy'); else body.setAttribute('aria-busy', aria); };
    }
    async function settleNotes() {
      // Both existing note editors debounce for at most 700ms. Disable edits
      // first, let their original writers flush, then drain both writer queues.
      var timeout;
      try {
        await Promise.race([
          new Promise(function (resolve) { setTimeout(resolve, 800); }).then(function () { return Promise.all([win.NL.cart.whenIdle(), coordinator.whenIdle()]); }),
          new Promise(function (_resolve, reject) { timeout = setTimeout(function () { reject(new Error('Note save did not settle')); }, 8000); })
        ]);
      } finally { clearTimeout(timeout); }
    }
    async function copy(model, before) {
      if (options.writeEnabled !== true) { observe('copy-disabled-no-cart-write'); throw new Error('Read-only cart relay transport candidate'); }
      model = validate(model);
      if (!lockedDepth || plan(model, validate(before)) !== 'copy') throw new Error('Cart copy requires an empty locked destination');
      await coordinator.assertNoPending();
      observe('first-party-cart-write');
      try {
        await request('cart/add.js', { items: model.items.map(function (item) { return { id: item.variantId, quantity: item.quantity, properties: item.properties }; }) });
        if (model.note || Object.keys(model.attributes).length) await request('cart/update.js', { note: model.note, attributes: model.attributes });
      } catch (error) {
        // Never retry an add or clear a partial cart. Content compatibility is
        // not proof of ownership against nonparticipating writers. An explicit
        // completed HTTP error permits a bounded readback only. A timeout/network failure has unknown server
        // completion, and a 429 requires a quiet stop without further requests.
        if (!Number.isInteger(error.status) || error.status === 429) throw error;
        var current = await read();
        if (fingerprint(current) === fingerprint(model)) { observe('desired-state-confirmed-after-error'); return; }
        observe('partial-or-unknown-destination-preserved-after-error');
        throw error;
      }
    }
    async function withLock(work) {
      if (!win.navigator || !win.navigator.locks || typeof win.navigator.locks.request !== 'function') return Promise.reject(new Error('Cart lock unavailable'));
      // Drain known writers before acquiring their shared lock. A writer queued
      // during our own GET is detected before add, without waiting on ourselves.
      var timeout;
      try {
        await Promise.race([Promise.all([win.NL.cart.whenIdle(), coordinator.whenIdle()]), new Promise(function (_resolve, reject) {
          timeout = setTimeout(function () { reject(new Error('Cart queue unavailable')); }, 8000);
        })]);
      } finally { clearTimeout(timeout); }
      return win.navigator.locks.request('nl-language-cart-relay-v1', { mode: 'exclusive', ifAvailable: true }, function (lock) {
        if (!lock) throw new Error('Another cart transfer is active');
        var restore = busy();
        lockedDepth += 1;
        var operation = transferId ? function () { return win.NLCartTransferFence.withLock(work); } : work;
        return Promise.resolve().then(operation).finally(function () { lockedDepth -= 1; restore(); });
      });
    }
    return { read: read, copy: copy, removeOriginal: removeOriginal, busy: busy, settleNotes: settleNotes, withLock: withLock, assertNoPending: coordinator.assertNoPending, normalize: function (raw) { return normalize(raw, context(raw)); } };
  }
  function install(win) {
    if (ORIGINS.indexOf(win.location.origin) < 0) return null;
    var trace = [];
    function observe(name) { trace.push({ phase: name, at: Date.now() }); if (trace.length > 40) trace.shift(); }
    var coordinator = createCoordinator(win);
    var adapter = createBrowserAdapter(win, { writeEnabled: RELAY_COPY_ENABLED, observe: observe, coordinator: coordinator }), active = null, incoming = null;
    function prepare(target) {
      if (active) throw new Error('Another language change is active');
      if (win.navigator.userActivation && !win.navigator.userActivation.isActive) throw new Error('Popup unavailable');
      var random = new Uint8Array(16); win.crypto.getRandomValues(random);
      var nonce = Array.from(random).map(function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
      var original = null;
      var session = createSource({ origin: win.location.origin, target: target, nonce: nonce, theme: win.Shopify.theme.id, themeRole: win.Shopify.theme.role, requireMove: true,
        open: function (url) { return win.open(url, '_blank', 'popup,width=620,height=760'); },
        listen: function (receive) { win.addEventListener('message', receive); return function () { win.removeEventListener('message', receive); }; },
        send: function (peer, origin, message) { peer.postMessage(message, origin); }, read: adapter.read, withSourceLock: adapter.withLock,
        moveSource: function (model, alive) { return adapter.removeOriginal(model, original, alive); },
        navigate: function (url) { win.location.assign(url); }, observe: observe });
      var wrapper = {
        transfer: async function (raw) {
          var restore = adapter.busy();
          try { await adapter.settleNotes(); original = raw; return await session.transfer(adapter.normalize(raw)); }
          catch (error) { wrapper.close(); throw error; }
          finally { restore(); }
        },
        navigate: session.navigate,
        close: function () { session.close(); if (active === wrapper) active = null; }
      };
      active = wrapper;
      return wrapper;
    }
    function receiverReady() {
      var opener;
      try { opener = win.opener; if (!opener || opener.closed) return; } catch (_) { return; }
      var receiver = createReceiver({ origin: win.location.origin, opener: opener, requireMove: true, read: adapter.read, copy: adapter.copy, withLock: adapter.withLock, assertNoPending: adapter.assertNoPending,
        send: function (peer, origin, message) { try { peer.postMessage(message, origin); } catch (_) {} }, observe: observe });
      incoming = receiver;
      win.addEventListener('message', function (event) { receiver.receive(event).catch(function () {}); });
      opener.postMessage({ v: 1, type: 'ready', theme: win.Shopify && win.Shopify.theme && win.Shopify.theme.id, country: win.Shopify && win.Shopify.country, currency: win.Shopify && win.Shopify.currency && win.Shopify.currency.active }, ORIGINS.find(function (origin) { return origin !== win.location.origin; }));
    }
    if (win.document.readyState === 'loading' || win.document.readyState === 'interactive') win.document.addEventListener('DOMContentLoaded', receiverReady, { once: true });
    else receiverReady();
    win.addEventListener('pagehide', function () { if (active) active.close(); if (incoming) incoming.abort(); });
    return { prepare: prepare, runMutation: coordinator.runMutation, whenIdle: coordinator.whenIdle, getProof: function () { return { mode: RELAY_COPY_ENABLED ? 'cart-transfer' : 'read-only-transport', origin: win.location.origin, trace: trace.map(function (entry) { return Object.assign({}, entry); }) }; } };
  }
  return { normalize: normalize, validate: validate, fingerprint: fingerprint, plan: plan, createReceiver: createReceiver, createSource: createSource, createBrowserAdapter: createBrowserAdapter, createCoordinator: createCoordinator, install: install };
});
